import { render, staticRenderFns } from "./ManifestKlaimPp.vue?vue&type=template&id=24d3e058&scoped=true&"
import script from "./ManifestKlaimPp.vue?vue&type=script&lang=js&"
export * from "./ManifestKlaimPp.vue?vue&type=script&lang=js&"
import style0 from "./ManifestKlaimPp.vue?vue&type=style&index=0&id=24d3e058&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d3e058",
  null
  
)

export default component.exports